import React from 'react';
import Modal from 'react-modal';
import './ForgotPasswordModal.css';

Modal.setAppElement('#root');

const ForgotPasswordModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content forgot-modal"
      overlayClassName="modal-overlay"
    >
      <div className="modal-header">
        <h2>¿Olvidaste tu contraseña?</h2>
        <hr />
      </div>

      <div className="modal-body">
        <p>Por seguridad, por favor contacta al área de TI.</p>
      </div>

      <div className="modal-actions">
        <button className="btn" onClick={onRequestClose}>
          Entendido
        </button>
      </div>
    </Modal>
  );
};

export default ForgotPasswordModal;